import { render, staticRenderFns } from "./DialogAddImagenes.vue?vue&type=template&id=589f09e6&scoped=true"
import script from "./DialogAddImagenes.vue?vue&type=script&lang=js"
export * from "./DialogAddImagenes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589f09e6",
  null
  
)

export default component.exports